<template>
    <modal name="payment-modal"
            @closed="$emit('updateComparisonData')"
            @before-close="beforeClose"
            @before-open="beforeOpen"
            style="z-index: 1000;"
    >
        <div id="modal-header" class="w-100 px-4 py-2 position-relative"
            style="background-color:#1e7bb7">
            <div class="w-100 d-flex">
                <h4 class="text-white">Վճարման եղանակներ</h4>
            </div>
            <button type="button"
                    class="close position-absolute"
                    style="right: 1.25rem; top: 30%"
                    @click="$modal.hide('payment-modal')" aria-label="Close">
                <span aria-hidden="true" class="text-white">&times;</span>
            </button>
        </div>
        <div class="d-flex flex-column mx-5 my-5">
            <label for="payment_methods" class="font-weight-bold">Ընտրել վճարման եղանակ</label>
            <div class="mt-4">
                <div class="d-flex align-items-center">
                    <input type="radio" id="bank_acc" name="payment" class="payment_radio cursor" value="1" v-model="checkedValue" @change="ischecked">
                    <label for="bank_acc" class="ml-2 mb-0 payment_label cursor">Բանկային փոխանցում</label>
                </div>

                <div class="d-flex align-items-center mt-2">
                    <input type="radio" id="card" name="payment" class="payment_radio cursor" value="2" v-model="checkedValue" @change="ischecked"> 
                    <label for="card" class="ml-2 mb-0 payment_label cursor d-flex align-items-center">
                        <div>
                            <img src="/assets/dashboard/assets/images/visa.svg" class="size">
                        </div>
                        <div>
                            <span class="mx-3">\</span>
                            <img src="/assets/dashboard/assets/images/мastercard.svg" class="size">
                        </div>
                        <div>
                            <span class="mx-3">\</span>
                            <img src="/assets/dashboard/assets/images/arca.svg" class="size1">
                        </div>
                        <div>
                            <span class="ml-3 mr-2">\</span>
                            <img src="/assets/dashboard/assets/images/amex.svg" class="size1">
                        </div>
                    </label>
                </div>
            </div>
        </div>
        <div class="mx-5 my-5" :class="{'d-none' : showContent}">
            <div>
                <p class="font-weight-bold color">Կազմակերպության անվանումը՝ « ԱՅ ՏԵՆԴԵՐ » ՍՊԸ</p>
                <p class="font-weight-bold color">Հասցե՝ ք.Երևան, Ազատության 24, 313 սենյակ,</p>
                <p class="font-weight-bold color">ՀՎՀՀ 05538076</p>
                <p class="font-weight-bold color">Բանկ՝ «ԱԿԲԱ ԿՐԵԴԻՏ ԱԳՐԻԿՈԼ ԲԱՆԿ » ՓԲԸ</p>
                <p class="font-weight-bold color">Հ/Հ 220453330569000</p>
                <p class="font-weight-bold color">Նպատակը՝ www.itender.am կայքի ծառայությունների փաթեթի /օրինակ՝ Պրեմիում փաթեթ և ժամկետը/ հասանելիության համար :</p>
            </div>
            <button class="btn btn-sm btn-primary" @click="SendData">Հաստատել</button>
        </div>
        <div class="mx-5 my-3">
            <button class="btn btn-sm btn-primary" :class="{'d-none' : showButton}" @click="cardPayment">Վճարել</button>
        </div>
    </modal>    
</template>
<script>
  export default{
    data(){
        return{
            checkedValue: 0,
            packageId: 0,
            selectedPrice: 0,
            showContent: true,
            showButton: true,
        }
    },
    methods:{
        beforeOpen({params}){
            this.packageId = params.packageId
            this.selectedPrice = params.selectedPrice
        },
        ischecked(){
            if(this.checkedValue === "2"){
                this.showContent = true
                this.showButton = false
            }
            if(this.checkedValue === "1"){
                this.showContent = false
                this.showButton = true
            }
        },
        SendData(){
            var idandmonth = {
                package_id: this.packageId,
                month:  this.selectedPrice,
            }
            this.$client.post('creat/order/bank/transfer', idandmonth).then(({data}) => {
                if(data.error){
                    this.$fire({
                      text: "Խնդրում ենք կատարել վճարումը, և 1 օրվա ընթացքում փաթեթը կակտիվանա: Շնորհակալություն համակարգից օգտվելու համար:",
                      type: "warning",
                      confirmButtonText: 'Լավ'
                    }).then(() => {
                        this.$modal.hide('payment-modal')
                    })
                }
            })
        },
        beforeClose(){
            this.checkedValue = null
            this.showContent = true
            this.showButton = true
        },
        cardPayment(){
            const requestData ={
                package_id: this.packageId,
                month:  this.selectedPrice,
                method: 'arca'
            }
            this.$client.post('create/order/payment/url', requestData).then(({data}) => {
                const { formUrl } = data
                window.location.href = formUrl
            })
        }
    }
  }                
</script>

<style scoped>
  /deep/ .vm--modal {
    top: 0 !important;
    bottom: 0 !important;
    right: 0 !important;;
    left: 0 !important;;
    margin: auto;
    position: absolute;
    overflow: inherit !important;
    width: 960px !important;
    /* height: auto !important; */
    padding-bottom: 0px;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
  .payment_radio{
      width: 18px;
      height: 18px;
  }
  .payment_label{
      color: black;
      font-size: 15px;
  }
  .cursor{
      cursor: pointer;
  }
  .color{
      color: #656d9a;
  }
  .size{
      width: 50px;
      height: 50px;
  } 
  .size1{
      width: 65px;
      height: 65px;
  }
</style>
